<template>
  <v-dialog
    v-model="deployDialog"
    persistent
    width="500"
  >
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip
        top
        color="primary"
      >
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
          >
            <v-icon>mdi-cloud-refresh</v-icon>
          </v-btn>
        </template>
        <span>Deploy</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="text-h5 accent lighten-2">
        Deploy Service
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              class="text-center"
            >
              <v-form
                ref="deployform"
                lazy-validation
              >
                <v-row>
                  <v-col
                    v-for="(service, i) in services"
                    :key="`service-${i}`"
                    cols="12"
                    sm="4"
                    md="4"
                    class="text-center"
                  >
                    <v-checkbox
                      v-model="selectedService"
                      :label="service"
                      :value="service"
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-text-field
                  v-model="reference"
                  :rules="[rules.required, rules.reference]"
                  label="Reference"
                />
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="deployDialog = false"
        >
          CANCEL
        </v-btn>
        <v-btn
          color="accent"
          @click="confirmDeployAction"
        >
          CONFIRM
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'DeployDialog',
    props: {
      contractName: String,
      contractNumber: String,
      server: Object,
    },
    data () {
      return {
        selectedService: [],
        selectedAction: 'deploy',
        reference: '',
        deployDialog: false,
        rules: {
          required: value => !!value || 'Required.',
          reference: value => {
            const pattern = /^[rstRST]?[0-9]{6,}$/
            if (value) {
              return pattern.test(value) || 'Invalid Reference.'
            } else {
              return true
            }
          },
        },
      }
    },
    computed: {
      services () {
        let serviceArray = []
        switch (this.server.server_type) {
          case 'WEB':
            serviceArray = ['assyst']
            break
          case 'CSR':
            if (this.server.reports === 'y') {
              serviceArray.push('reports')
            }
            if (this.server.chat === 'y') {
              serviceArray.push('chat')
            }
            if (this.server.search === 'y') {
              serviceArray.push('search')
            }
            break
        }
        return serviceArray
      },
      serviceObject () {
        return {
          data: {
            server_ip: this.server.private_ip_address,
            server_name: this.server.Name,
            service_action: this.selectedAction,
            service_name: this.selectedService,
            customer: this.contractName,
            contract: this.contractNumber,
            reference: this.reference,
            switches: this.getDeploySwitches(this.selectedService),
          },
        }
      },
    },
    methods: {
      confirmDeployAction: function () {
        if (this.$refs.deployform.validate()) {
          this.deployDialog = false

          this.$emit('deployService', this.serviceObject)
        }
      },
      getDeploySwitches: function (services) {
        var switches = ''
        services.forEach(element => {
          switches += ' -' + element.substr(0, 1)
        })

        if (switches.length > 0) {
          return switches.substr(1)
        } else {
          return switches
        }
        
      }
    },
  }
</script>
